module.exports = __webpack_public_path__ + "img/kommune-226.d242b949.svg";